/* =========================================================
   GUEST PARTY-MEMBER ONBOARDING
   Shown when URL contains ?partyToken=<UUID>
   All requests use gasPostGuest() — no bride email/customerId
   ========================================================= */
(function () {
  // Endpoint comes from the ROUTE -> BACKEND MAP in
  // jv-bridal-hub-resilience.js, so a guest route can be moved to a Worker
  // with a one-line change there.
  //
  // DELIBERATELY NOT MIGRATED ONTO jvHubFetch: this is the ?partyToken guest
  // flow. jvHubFetch always attaches email + customerId (+ weddingDate) from
  // JV_HUB_CTX, which a guest does not have and must not send -- guests
  // authenticate by party token alone. Sharing the URL map is correct here;
  // sharing the bride-auth transport is not.
  function _resolve(route) {
    // FIXED 2026-08-13 (raw-GAS-URL bypass sweep). This fallback only fires if
    // jv-bridal-hub-resilience.js somehow failed to load, but it was still the raw GAS URL,
    // bypassing the Cloudflare CORS relay that absorbs the ~7-10s GAS cold-start. The relay
    // worker default is now used here too, so even the fallback path stays fast.
    return (window.jvHub && window.jvHub.resolveUrl)
      ? window.jvHub.resolveUrl(route)
      : 'https://broken-truth-efdd.calm-hill-fd5b.workers.dev';
  }
  var _nativeFetch = window._jvNativeFetch || fetch.bind(window);

  var _partyToken         = '';
  var _resolvedMemberName = '';
  var _resolvedMemberRole = 'Party Member';
  var _resolvedExisting   = null;
  var _uploadedFileIds    = [];

  function gasPostGuest(route, payload, onSuccess, onError) {
    var body = { route: route };
    if (payload && typeof payload === 'object') {
      Object.keys(payload).forEach(function (k) { body[k] = payload[k]; });
    }
    _nativeFetch(_resolve(route), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(body)
    }).then(function (res) { return res.text(); })
      .then(function (text) {
        var data = null;
        try { data = JSON.parse(text); } catch (e) {}
        if (onSuccess) onSuccess(data);
      })
      .catch(function (err) { if (onError) onError(err); });
  }

  function showState(name) {
    ['loading', 'error', 'orientation', 'confirm', 'form', 'success'].forEach(function (s) {
      var el = document.getElementById('jv-guest-state-' + s);
      if (el) el.style.display = s === name ? '' : 'none';
    });
  }

  function _esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Orientation (item 4) ───────────────────────────────── */
  // Copy pattern matches the build brief's own worked example verbatim: who sent this, why, how
  // long it takes, what happens after.
  function renderOrientation(data, memberFirst, brideFirst) {
    var headingEl = document.getElementById('jv-guest-orientation-heading');
    var bodyEl = document.getElementById('jv-guest-orientation-body');
    var factsEl = document.getElementById('jv-guest-orientation-facts');
    var brideDisplay = brideFirst || 'Your bride';
    // brideRow is the bride's CRM row, already included in the resolveToken response (existing
    // field, not new); WEDDING DATE is DD/MM/YYYY Australian format straight from the sheet, no
    // reformatting needed for this one-line orientation sentence.
    var weddingDateLabel = (data.brideRow && data.brideRow['WEDDING DATE']) || '';

    if (headingEl) headingEl.textContent = 'Hi ' + (memberFirst || 'there') + ',';
    if (bodyEl) {
      bodyEl.textContent = brideDisplay + ' has asked you to complete your beauty profile' +
        (weddingDateLabel ? ' for her wedding on ' + weddingDateLabel : ' for her wedding') +
        '. It takes about 3 minutes.';
    }
    if (factsEl) {
      var facts = [
        'Your role: ' + (_resolvedMemberRole || 'Party Member'),
        'What happens after: the team uses this to prepare your hair and makeup on the day.'
      ];
      factsEl.innerHTML = facts.map(function (f) {
        return '<li>' + _esc(f) + '</li>';
      }).join('');
    }
  }

  /* ── Confirm, don't re-ask (item 4) ─────────────────────── */
  var CONFIRM_FIELD_LABELS = {
    hairStyle: 'Hair style preference',
    colourPalette: 'Colour palette preference',
    skinConcerns: 'Skin concerns',
    allergies: 'Allergies or sensitivities'
  };

  function showConfirmOrForm(data, brideFirst) {
    if (_resolvedExisting) {
      renderConfirmCard(_resolvedExisting);
      showState('confirm');
    } else {
      showState('form');
    }
  }

  function renderConfirmCard(existing) {
    var listEl = document.getElementById('jv-guest-confirm-list');
    if (!listEl) return;
    var rows = Object.keys(CONFIRM_FIELD_LABELS)
      .filter(function (k) { return existing[k]; })
      .map(function (k) {
        return '<dt>' + _esc(CONFIRM_FIELD_LABELS[k]) + '</dt><dd>' + _esc(existing[k]) + '</dd>';
      });
    listEl.innerHTML = rows.join('');

    var yesBtn = document.getElementById('jv-guest-confirm-yes');
    var editBtn = document.getElementById('jv-guest-confirm-edit');
    var statusEl = document.getElementById('jv-guest-confirm-status');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        yesBtn.disabled = true;
        yesBtn.textContent = 'Confirming…';
        // "Confirm" submits the SAME values already on file through the normal submit route,
        // it is not a new write path: the guest is telling us what we already have is correct.
        gasPostGuest('bridge_guest_submitOnboarding', {
          partyToken: _partyToken,
          formData: {
            colourPalette: existing.colourPalette || '',
            hairStyle: existing.hairStyle || '',
            skinConcerns: existing.skinConcerns || '',
            allergies: existing.allergies || '',
            inspoNotes: '',
            fileIds: [],
            inspirationTypes: []
          }
        }, function (res) {
          if (res && res.success) {
            sessionStorage.removeItem('jv_party_token_raw');
            showState('success');
          } else {
            if (statusEl) {
              statusEl.style.display = '';
              statusEl.textContent = 'That didn’t save. Please try again.';
            }
            yesBtn.disabled = false;
            yesBtn.textContent = 'Yes, that’s right';
          }
        }, function () {
          if (statusEl) {
            statusEl.style.display = '';
            statusEl.textContent = 'We couldn’t reach the server. Please try again.';
          }
          yesBtn.disabled = false;
          yesBtn.textContent = 'Yes, that’s right';
        });
      }, { once: true });
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        prefillFormFromExisting(existing);
        showState('form');
      }, { once: true });
    }
  }

  function prefillFormFromExisting(existing) {
    ['colourPalette', 'hairStyle'].forEach(function (field) {
      if (!existing[field]) return;
      var chip = document.querySelector('.jv-guest-chip[data-field="' + field + '"][data-value="' + existing[field].replace(/"/g, '\\"') + '"]');
      if (chip) chip.classList.add('is-selected');
    });
    if (existing.skinConcerns) {
      var skinEl = document.getElementById('jv-guest-skin');
      if (skinEl) skinEl.value = existing.skinConcerns;
    }
    if (existing.allergies) {
      var allergyEl = document.getElementById('jv-guest-allergies');
      if (allergyEl) allergyEl.value = existing.allergies;
    }
  }

  /* ── Upload helpers ─────────────────────────────────────── */

  function uploadFile(file, category, statusEl, onDone) {
    statusEl.textContent = 'Uploading…';
    statusEl.className = 'jv-guest-upload__status';
    var reader = new FileReader();
    reader.onload = function (ev) {
      var dataUrl = ev.target.result;
      var b64 = dataUrl.split(',')[1];
      var mime = file.type || 'image/jpeg';
      gasPostGuest('bridge_party_uploadInspoImage', {
        memberContext:    'partyMember',
        partyToken:       _partyToken,
        targetMemberName: _resolvedMemberName,
        targetMemberRole: _resolvedMemberRole,
        category:         category,
        base64Content:    b64,
        mimeType:         mime,
        filename:         file.name
      }, function (res) {
        if (res && res.ok) {
          if (res.fileId) _uploadedFileIds.push(res.fileId);
          if (onDone) onDone(res, file);
        } else {
          statusEl.textContent = (res && res.error) ? res.error : 'Upload failed. Please try again.';
          statusEl.className = 'jv-guest-upload__status is-error';
        }
      }, function () {
        statusEl.textContent = 'Network error. Please try again.';
        statusEl.className = 'jv-guest-upload__status is-error';
      });
    };
    reader.onerror = function () {
      statusEl.textContent = 'Could not read file. Please try again.';
      statusEl.className = 'jv-guest-upload__status is-error';
    };
    reader.readAsDataURL(file);
  }

  function showLocalPreview(file, imgEl) {
    var r = new FileReader();
    r.onload = function (ev) { imgEl.src = ev.target.result; };
    r.readAsDataURL(file);
  }

  function wireProfileUpload() {
    var input    = document.getElementById('jv-guest-profile-input');
    var thumbEl  = document.getElementById('jv-guest-profile-thumb');
    var statusEl = document.getElementById('jv-guest-profile-status');
    if (!input || !thumbEl || !statusEl) return;
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;

      // Show local preview immediately — don't wait for Drive
      var img = document.createElement('img');
      img.alt = 'Profile photo';
      thumbEl.innerHTML = '';
      thumbEl.appendChild(img);
      showLocalPreview(file, img);

      uploadFile(file, 'ProfilePic', statusEl, function () {
        statusEl.textContent = 'Photo saved!';
      });
    });
  }

  function wireInspoUpload(inputId, category, thumbsId, statusId) {
    var input    = document.getElementById(inputId);
    var thumbsEl = document.getElementById(thumbsId);
    var statusEl = document.getElementById(statusId);
    if (!input || !thumbsEl || !statusEl) return;
    input.addEventListener('change', function () {
      var files = input.files;
      if (!files || !files.length) return;

      for (var i = 0; i < files.length; i++) {
        (function (file) {
          // Show local preview immediately — don't wait for Drive
          var img = document.createElement('img');
          img.className = 'jv-guest-upload__preview';
          img.alt = category + ' inspo';
          thumbsEl.appendChild(img);
          showLocalPreview(file, img);

          uploadFile(file, category, statusEl, function () {
            var n = thumbsEl.querySelectorAll('img').length;
            statusEl.textContent = n + (n === 1 ? ' photo saved' : ' photos saved');
          });
        })(files[i]);
      }
      input.value = '';
    });
  }

  /* ── Main init ──────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function () {
    _partyToken = sessionStorage.getItem('jv_party_token_raw');
    if (!_partyToken) return;

    var guestSection = document.getElementById('jv-guest-onboarding');
    if (!guestSection) return;

    guestSection.style.display = '';
    guestSection.removeAttribute('aria-hidden');
    showState('loading');

    // Resolve token → personalise UI
    gasPostGuest('bridge_guest_resolveToken', { partyToken: _partyToken }, function (data) {
      if (!data) {
        document.getElementById('jv-guest-error-msg').textContent =
          'This invite link has expired or is no longer valid. Ask your bride to send you a new link.';
        showState('error');
        return;
      }

      _resolvedMemberName = data.memberName || '';
      _resolvedMemberRole = data.memberRole || 'Party Member';
      _resolvedExisting    = data.existing || null;

      var memberFirst = (_resolvedMemberName || 'there').split(' ')[0];
      var brideFirst  = (data.brideName || '').split(' ')[0];

      var headingEl = document.getElementById('jv-guest-heading');
      var subtextEl = document.getElementById('jv-guest-subtext');
      if (headingEl) headingEl.textContent = 'Hey ' + memberFirst + '!';
      if (subtextEl) subtextEl.textContent =
        (brideFirst ? brideFirst + ' has ' : 'Your bride has ') +
        'invited you to fill in your beauty profile so the team is ready for the big day.';

      wireProfileUpload();
      wireInspoUpload('jv-guest-hair-input',   'Hair',   'jv-guest-hair-thumbs',   'jv-guest-hair-status');
      wireInspoUpload('jv-guest-makeup-input', 'Makeup', 'jv-guest-makeup-thumbs', 'jv-guest-makeup-status');

      // Orientation (item 4): one screen, once per token, answering who sent this, why, how
      // long it takes, and what happens after (build brief's own worked example). Skipped on a
      // repeat visit with the same token in the same browser session so it never nags someone
      // returning to finish a form they started.
      var orientationSeenKey = 'jv_guest_orientation_seen_' + _partyToken;
      var alreadySeen = false;
      try { alreadySeen = sessionStorage.getItem(orientationSeenKey) === '1'; } catch (e) {}

      if (alreadySeen) {
        showConfirmOrForm(data, brideFirst);
      } else {
        renderOrientation(data, memberFirst, brideFirst);
        showState('orientation');
        var continueBtn = document.getElementById('jv-guest-orientation-continue');
        if (continueBtn) {
          continueBtn.addEventListener('click', function () {
            try { sessionStorage.setItem(orientationSeenKey, '1'); } catch (e) {}
            showConfirmOrForm(data, brideFirst);
          }, { once: true });
        }
      }

    }, function () {
      document.getElementById('jv-guest-error-msg').textContent =
        'We couldn’t reach the server. Please check your connection and try again.';
      showState('error');
    });

    // Chip selection (single-select per data-field group)
    var guestCard = document.getElementById('jv-guest-state-form');
    if (guestCard) {
      guestCard.addEventListener('click', function (e) {
        var chip = e.target.closest('.jv-guest-chip');
        if (!chip) return;
        var field = chip.dataset.field;
        if (!field) return;
        guestCard.querySelectorAll('.jv-guest-chip[data-field="' + field + '"]').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        chip.classList.add('is-selected');
      });
    }

    // Form submit
    var guestForm      = document.getElementById('jv-guest-form');
    var guestSubmitBtn = document.getElementById('jv-guest-submit-btn');
    if (!guestForm || !guestSubmitBtn) return;

    guestForm.addEventListener('submit', function (e) {
      e.preventDefault();
      guestSubmitBtn.disabled = true;
      guestSubmitBtn.textContent = 'Saving…';

      function getChipValue(field) {
        var active = guestForm.querySelector('.jv-guest-chip.is-selected[data-field="' + field + '"]');
        return active ? active.dataset.value : '';
      }
      function getTextValue(id) {
        var el = document.getElementById(id);
        return el ? el.value.trim() : '';
      }

      var formData = {
        colourPalette:    getChipValue('colourPalette'),
        hairStyle:        getChipValue('hairStyle'),
        skinConcerns:     getTextValue('jv-guest-skin'),
        allergies:        getTextValue('jv-guest-allergies'),
        inspoNotes:       getTextValue('jv-guest-inspo'),
        fileIds:          _uploadedFileIds.slice(),
        inspirationTypes: []
      };

      gasPostGuest('bridge_guest_submitOnboarding', { partyToken: _partyToken, formData: formData },
        function (res) {
          if (res && res.success) {
            sessionStorage.removeItem('jv_party_token_raw');
            var sh = document.getElementById('jv-guest-success-heading');
            var sb = document.getElementById('jv-guest-success-body');
            if (sh) sh.textContent = 'You’re all set!';
            if (sb) sb.textContent = 'Your beauty profile has been saved. The team will have everything they need on the day — see you soon!';
            showState('success');
          } else {
            guestSubmitBtn.disabled = false;
            guestSubmitBtn.textContent = 'Submit my beauty profile';
            alert((res && res.error) ? res.error : 'Something went wrong. Please try again.');
          }
        },
        function () {
          guestSubmitBtn.disabled = false;
          guestSubmitBtn.textContent = 'Submit my beauty profile';
          alert('Network error. Please check your connection and try again.');
        }
      );
    });
  });
})();
